import Highcharts from 'highcharts';
import { NumericSeriesDataItem } from './map-numeric-main-series';
import {
    TimelineAxisTypes,
    TimelineNumericSeries,
    TimelineSeriesCustomData,
} from '@pages-clean/subject-monitoring/subject-profile/tabs/timeline/shared';

type MapNumericThresholdSeriesOptions = {
    parentSeries: (Highcharts.SeriesLineOptions | Highcharts.SeriesScatterOptions) & TimelineSeriesCustomData;
    series: TimelineNumericSeries;
    key: 'Upper' | 'Lower';
};
export function mapNumericThresholdSeries({
    parentSeries,
    series,
    key,
}: MapNumericThresholdSeriesOptions): (Highcharts.SeriesLineOptions & TimelineSeriesCustomData) | null {
    const dataWithThreshold = (series.data as NumericSeriesDataItem[])
        .filter((x) => x.value.Threshold?.[key] != null)
        .map((item) => [new Date(item.value.Date).getTime(), item.value.Threshold![key]!]);

    // Nothing to map...
    if (dataWithThreshold.length === 0) {
        return null;
    }

    return {
        ...parentSeries,
        id: `${parentSeries.id}_${key.toLowerCase()}Threshold`,
        name: `${parentSeries.name} - ${key} Threshold`,
        type: 'line',
        lineWidth: 1,
        dashStyle: 'Dash',
        linkedTo: parentSeries.id,
        data: dataWithThreshold,
        marker: {
            symbol: 'circle',
            enabled: false,
        },
        isThreshold: true,
        custom: {
            axisType: TimelineAxisTypes.Numeric,
        },
        unit: parentSeries.unit,
    };
}
